"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Copyright 2013-present, Novivia, Inc.
                    * All rights reserved.
                    */

var _configurations = require("@auex/configurations");

var _Label = require("react-bootstrap/Label");

var _Label2 = _interopRequireDefault(_Label);

var _currency = require("currency");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LotStatusLabel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LotStatusLabel, _Component);

  function LotStatusLabel() {
    (0, _classCallCheck3.default)(this, LotStatusLabel);
    return (0, _possibleConstructorReturn3.default)(this, (LotStatusLabel.__proto__ || (0, _getPrototypeOf2.default)(LotStatusLabel)).apply(this, arguments));
  }

  (0, _createClass3.default)(LotStatusLabel, [{
    key: "render",
    value: function render() {
      var _context = this.context,
          __ = _context.__,
          currency = _context.currency;


      var bsStyle = void 0;
      var statusMessage = void 0;
      var extraInformation = null;

      switch (this.props.status) {
        case _configurations.AE_LOT_STATUS.OPEN:
          statusMessage = __("lot::status.open");
          bsStyle = "primary";
          break;

        case _configurations.AE_LOT_STATUS.CANCELLED:
          statusMessage = __("lot::status.cancelled");
          bsStyle = "danger";
          break;

        case _configurations.AE_LOT_STATUS.SOLD:
          statusMessage = __("lot::status.sold");
          bsStyle = "success";

          if (this.props.winningBidAmount) {
            extraInformation = _react2.default.createElement(
              "span",
              null,
              " – ",
              (0, _currency.formatMoney)(this.props.winningBidAmount, currency)
            );
          }
          break;

        default:
          bsStyle = "default";
          statusMessage = __("general::unknown");
      }

      return _react2.default.createElement(
        _Label2.default,
        {
          bsStyle: bsStyle,
          className: "lot-status-label"
        },
        statusMessage.toUpperCase(),
        extraInformation
      );
    }
  }]);
  return LotStatusLabel;
}(_react.Component), _class.propTypes = {
  // Status of the lot.
  status: _propTypes2.default.oneOf(_configurations.AE_LOT_STATUS.getValues()),

  // Amount the the lot was sold for.
  winningBidAmount: _propTypes2.default.number
}, _class.contextTypes = {
  // Translation utility.
  __: _propTypes2.default.func.isRequired,

  // ISO code for the currency to use when displaying amounts of money.
  currency: _propTypes2.default.string
}, _temp);
exports.default = LotStatusLabel;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/LotStatusLabel.jsx
// module id = 409
// module chunks = 9 15 19 23